<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>


    <!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 점검대상
        </h5>
      </vs-col>
    </vs-row>

    <div class="grid grid-cols-8 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center">
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_1"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_1 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_1"
            ></vs-checkbox>
         {{inspectionTitle_1}}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_2"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_2 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_2"
            ></vs-checkbox>
         {{inspectionTitle_2}}
          </span>
        </div>
      </div>
    </div>

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_1"
      :list="form.inspectList_1"
      @update-list-check="updateListCheck_1"
      v-if="form.check_1"
    />
    <!--    기타 낙하물 등-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_2"
      :list="form.inspectList_2"
      @update-list-check="updateListCheck_2"
      v-if="form.check_2"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"/>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        if (!this.form || !this.form.inspectList_1 || this.form.inspectList_1.length === 0) {
          this.form.inspectList_1 = this.inspectTable_1
        }
        if (!this.form || !this.form.inspectList_2 || this.form.inspectList_2.length === 0) {
          this.form.inspectList_2 = this.inspectTable_2
        }
        if (!this.form || !this.form.inspectList_3 || this.form.inspectList_3.length === 0) {
          this.form.inspectList_3 = this.inspectTable_3
        }
        if (!this.form || !this.form.inspectList_4 || this.form.inspectList_4.length === 0) {
          this.form.inspectList_4 = this.inspectTable_4
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.form.inspectionTitle
          = `${value.check_1 ? this.inspectionTitle_1 : ''}
            ${value.check_2 ? this.inspectionTitle_2 : ''}`

        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      inspectionTitle_1:'중량물 및 슬링·훅',
      inspectionTitle_2:'기타 낙하물 등',

      form: {
        inspectionTitle:'',
        stdInfo: { },
        photoList: [],
        check_1: true,
        check_2: false,
        fileList: [],
        equipmentList: [],
        inspectList_1: [],
        inspectList_2: [],
      },
    }
  },
  computed: {
    inspectTable_1 () {
      return [
        {
          id: 1,
          label: '중량물 취급 작업계획서*를 작성하고, 작업지휘자를 지정하여 작업계획서에 따라 작업을 지휘하도록 조치한다. *추락·낙하·전도·협착·붕괴위험 예방대책',
          is_checked: '',
          title: '중량물',
        },
        {
          id: 2,
          label: '비·눈·바람 또는 그 밖의 기상상태가 불안정한 경우 중량물 인양 작업을 중지한다.',
          is_checked: '',
          title: '중량물',
        },
        {
          id: 3,
          label: '중량물 인양작업 구간은 미리 작업자의 출입을 통제하여 인양중인 화물이 작업자의 머리 위로 통과하지 않도록 조치한다.',
          is_checked: '',
          title: '중량물',
        },
        {
          id: 4,
          label: '양중기로 철근을 운반할 경우에는 두 군데 이상 묶어서 수평으로 운반한다.',
          is_checked: '',
          title: '중량물',
        },
        {
          id: 5,
          label: '와이어로프 등이 훅으로부터 벗겨지는 것을 방지하기 위한 훅 해지장치의 설치여부를 확인한다',
          is_checked: '',
          title: '슬링·훅',
        },
        {
          id: 6,
          label: '달기구의 최대 허용하중 등의 표식이 견고하게 붙어 있는 것을 사용한다.',
          is_checked: '',
          title: '슬링·훅',
        },
        {
          id: 7,
          label: '와이어로프·달기체인·섬유로프·슬링벨트, 훅·샤클·링 등의 철구의 손상여부를 작업 전, 작업 중에 수시로 확인한다.',
          is_checked: '',
          title: '슬링·훅',
        },
        {
          id: 8,
          label: '변형되어 있는 훅·샤클·클램프 및 링 등의 철구로서 변형되어 있는 것 또는 균열이 있는 것을 크레인 및 이동식크레인의 고리걸이용구로 사용하지 않는다.',
          is_checked: '',
          title: '슬링·훅',
        },
        {
          id: 9,
          label: '중량물을 운반하기 위해 제작하는 지그, 훅의 구조를 운반 중 주변 구조물과의 충돌로 슬링이 이탈되지 않도록 하여야 한다.',
          is_checked: '',
          title: '슬링·훅',
        },
        {
          id: 10,
          label: '늘어난 달기체인이나 꼬임이 끊어진 섬유로프의 사용을 금지한다.',
          is_checked: '',
          title: '슬링·훅',
        },
      ]
    },
    inspectTable_2 () {
      return [
        {
          id: 1,
          label: '물체가 떨어지거나 날아올 위험이 있는 장소의 모든 작업자에게 안전모, 안전화를 지급하고 착용하도록 한다.',
          is_checked: '',
          title: '보호구 지급',
        },
        {
          id: 2,
          label: '낙하물방지망을 설치하는 경우 높이 10미터 이내마다, 내민 길이는 벽면으로부터 2m 이상으로 설치하고, 수평면과의 각도는 20도 이상 30도 이하를 유지한다.',
          is_checked: '',
          title: '낙하물 방지망 등',
        },
        {
          id: 3,
          label: '낙하물방지망 및 수직보호망은「산업표준화법」에 따른 한국산업표준에서 정하는 성능기준에 적합한 것을 사용한다.',
          is_checked: '',
          title: '낙하물 방지망 등',
        },
        {
          id: 4,
          label: '외부 비계와 외벽의 틈에 낙하물 방지망(쪽망)을 설치하여 비계와 외벽의 틈새로 낙하물이 떨어지는 것을 방지한다.',
          is_checked: '',
          title: '낙하물 방지망 등',
        },
        {
          id: 5,
          label: '외부 비계는 수직보호망을 촘촘히 설치하여 부품, 자재 등의 낙하를 방지한다.',
          is_checked: '',
          title: '낙하물 방지망 등',
        },
        {
          id: 6,
          label: '작업현장 내 통로, 출입구 등 작업자가 통행하는 구간에 방호선반을 설치한다.',
          is_checked: '',
          title: '낙하물 방지망 등',
        },
        {
          id: 7,
          label: '슬라브 단부, 개구부에 안전난간을 설치하는 경우 발끝막이판은 바닥면 등으로부터 10센티미터 이상의 높이를 유지하거나, 난간에 수직보호망을 설치하여 낙하물을 방지한다.',
          is_checked: '',
          title: '발끝막이판',
        },
        {
          id: 8,
          label: '슬라브의 단부, 개구부 주변, 비계 등에 자재, 부품 등을 쌓아두지 않는다.',
          is_checked: '',
          title: '기타',
        },

      ]
    },

  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck_1 (indexRows, text) {
      this.form.inspectList_1[indexRows].is_checked = text
    },
    updateListCheck_2 (indexRows, text) {
      this.form.inspectList_2[indexRows].is_checked = text
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
